a
<template>
  <div class="conatiner-fluid">
    <loading v-if="renderLoading"></loading>
    <div class="row p-2">
      <div class="col-md-3 col-12">
        <button @click="NewSafte" class="btn btn-success">
          ثبت سفته جدید
          <i class="fas fa-plus"></i>
        </button>
      </div>
      <div class="col-md-9 col-12"></div>
    </div>
    <div class="row m-2 border rounded p-2 mb-4 border-right-danger">
      <div class="col-12">
        <h5>پیش نویس سفته</h5>
        <hr />
      </div>
      <div v-for="(item, index) in SafteUnPayed" :key="index" class="col-12 border rounded m-2">
        <div class="row py-2">
          <div class="col-2">{{ 'مبلغ: ' + $Comma3ragham(item.amount) + $cookies.get('VahedPool') }}</div>
          <div class="col-2">{{ 'تاریخ :' + item.dateTimeInsert.substring(0, 10) }}</div>
          <div class="col-2">{{ 'توضیحات :' + item.description.substring(0, 20) }}</div>
          <div class="col-2">
            <button class="btn btn-warning"><a download="Safte.PDF" target="_blank" :href="'data:application/pdf;base64,' + item.unsigned_data">مشاهده سفته</a></button>
          </div>
          <div class="col-2">
            <button @click="paySafte(item)" class="btn btn-info">پرداخت هزینه سفته</button>
          </div>
          <div class="col-2">
            <button @click="deletePishnevis(item)" class="btn btn-danger">حذف پیش نویس سفته</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row m-2 border rounded p-2 mt-4 border-right-warning">
      <div class="col-12">
        <h5>سفته های امضا نشده</h5>
        <hr />
      </div>
      <div v-for="(item, index) in SaftePayed" :key="index" class="col-12 border rounded m-2">
        <div class="row py-2">
          <div class="col-3">{{ 'نام متعهد :' + item.moteahedNameFamily }}</div>
          <div class="col-3">{{ 'تاریخ :' + item.dateTimeInsert.substring(0, 10) }}</div>
          <div class="col-3">
            <button class="btn btn-info"><a class="text-light" download="Safte.PDF" target="_blank" :href="'data:application/pdf;base64,' + item.unsigned_data">مشاهده سفته</a></button>
          </div>
          <div class="col-3">
            <button class="btn btn-primary" @click="Signs(item)">امضای سفته</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row m-2 border rounded p-2 mt-4 border-right-success">
      <div class="col-12">
        <h5>سفته های نهایی شده</h5>
        <hr />
      </div>
      <div v-for="(item, index) in SafteFinall" :key="index" class="col-12 border rounded m-2 bg-light">
        <div class="row py-2">
          <div class="col-3">{{ 'نام متعهد :' + item.moteahedNameFamily }}</div>
          <div class="col-3">{{ 'تاریخ :' + item.dateTimeInsert.substring(0, 10) }}</div>
          <div class="col-3">
            <button v-if="item.FinallData == null" @click="SafteFinally(item)" class="btn btn-primary">استعلام نهایی سفته</button>
            <button v-else download="Safte.PDF" target="_blank" :href="'data:application/pdf;base64,' + item.FinallData" class="btn btn-primary">دانلود سفته</button>
          </div>
          <div class="col-3"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Loading from '../../Tools/NetPa/Loading.vue'
export default {
  components: { Loading },
  data() {
    return {
      renderLoading: false,
      SafteUnPayed: [],
      SaftePayed: [],
      SafteFinall: [],
    }
  },
  props: ['Sign'],
  methods: {
    GetList() {
      var GetParams = { method: 'POST', action: 'ElectronicSafte/GetSafteList', arryfildValue: {} }
      this.$PostData_netpatoken(GetParams).then((result) => {
        // console.log(result)
        this.SafteUnPayed = result.filter((x) => !x.paymentSuccess)
        this.SaftePayed = result.filter((x) => x.paymentSuccess == true && x.isSubmited == false)
        this.SafteFinall = result.filter((x) => x.paymentSuccess == true && x.isSubmited == true)
      })
    },
    paySafte(safte) {
      var DataAxiosAdd = {
        BnpInfo: {
          CustCode: this.$session.get('CustCode'),
          BnpToken: this.$session.get('TokenNetPa'),
          LoginCodeMelli: this.$session.get('UserInfoNetPa').codeMeli,
        },
        callback_url: window.location.host + '/VerifySafte',
        request_id: safte.request_id,
      }
      var AxiosData = { method: 'POST', action: 'ElectronicSafte/LinkPay', arryfildValue: DataAxiosAdd }
      this.$PostData_netpatoken(AxiosData).then((result) => {
        if (result.status == 'success') {
          window, (location = result.data.payment_gateway_link)
        } else {
          this.$mySweetDefault('مشکلی بوجود آمده است', result.data.errors[0].message, 'error', 1500)
        }
      })
    },
    NewSafte() {
      this.$emit('NewSafte', null)
    },
    Signs(safte) {
      this.$emit('SignF', safte)
    },
    SafteFinally(safte) {
      this.renderLoading = true
      var DataAxios = {
        method: 'POST',
        action: 'ElectronicSafte/SafteFinally',
        arryfildValue: {
          BnpInfo: {
            CustCode: this.$session.get('CustCode'),
            BnpToken: this.$session.get('TokenNetPa'),
            LoginCodeMelli: this.$session.get('UserInfoNetPa').codeMeli,
          },
          request_id: safte.request_id,
          signed_pdf: safte.signed_pdf,
        },
      }

      this.$PostData_netpatoken(DataAxios)
        .then((result) => {
          this.GetListData()
        })
        .finally(() => {
          this.renderLoading = false
        })
    },
    deletePishnevis(safte) {
      this.renderLoading = true
      var DataAxios = {
        method: 'POST',
        action: 'ElectronicSafte/DeletePishnevis',
        arryfildValue: {
          BnpInfo: {
            CustCode: this.$session.get('CustCode'),
            BnpToken: this.$session.get('TokenNetPa'),
            LoginCodeMelli: this.$session.get('UserInfoNetPa').codeMeli,
          },
          request_id: safte.request_id,
          signed_pdf: safte.signed_pdf,
        },
      }

      this.$PostData_netpatoken(DataAxios)
        .then((result) => {
          if ((result.status = 'success')) {
            this.$mySweetDefault(' عملیات موفق!', 'پیش نویس سفته با موفقیت حذف شد.', 'success', 1500)

            this.GetList()
          } else {
            this.$mySweetDefault(' عملیات ناموفق!', 'مشکلی در حذف سفته بوجود آمده است.', 'error', 1500)
          }
        })
        .finally(() => {
          this.renderLoading = false
        })
    },
  },
  created() {
    
    this.GetList()
  },
}
</script>
<style>
button.btn {
  font-size: 12px !important;
}
</style>
